import _ from "lodash";
import { htmlToText } from "html-to-text";

export function getSlideText(elements, returnList = false, keepHtml = false) {
    function getText(key, value, items) {
        if (key === "text" && typeof value === "string") {
            items.push(value.replace(/\r/g, " "));
        } else if (key === "wordcloud") {
            items.push(JSON.parse(value).map(w => w.word).join(" | "));
        } else if (key === "html") {
            const text = keepHtml
                ? value : htmlToText(value, { wordwrap: false });
            items.push(text);
        } else if (Array.isArray(value)) {
            value.forEach(item => {
                getText(key, item, items);
            });
        } else if (_.isObject(value)) {
            for (const subKey in value) {
                const subValue = value[subKey];
                getText(subKey, subValue, items);
            }
        }
    }

    const items = [];
    for (const key in elements) {
        const value = elements[key];
        getText(key, value, items);
    }

    const textList = _.chain(items).compact().uniq().value();
    return returnList ? textList : textList.join(" | ");
}

export function setSlideText(elements, textParts) {
    const newElements = _.cloneDeep(elements);

    function setText(key, value, path) {
        if (key === "text" && typeof value === "string") {
            _.set(newElements, path, textParts.shift());
        } else if (key === "wordcloud") {
            _.set(newElements, path, textParts.split(" | ").map(w => ({ word: w })));
        } else if (key === "html") {
            _.set(newElements, path, textParts.shift());
        } else if (Array.isArray(value)) {
            value.forEach((item, index) => {
                setText(key, item, [...path, index]);
            });
        } else if (_.isObject(value)) {
            for (const subKey in value) {
                const subValue = value[subKey];
                setText(subKey, subValue, [...path, subKey]);
            }
        }
    }

    for (const key in elements) {
        const value = elements[key];
        setText(key, value, [key]);
    }

    return newElements;
}
